import { styled } from "@mui/material";

export const Wrapper = styled("div")`
	display: flex;
	gap: 0.05em;
	text-align: center;
	align-items: center;
	color: #fbbd05;
	//text-shadow: 0.03em 0.03em #000;
	-webkit-text-stroke-width: 0.04em;
	-webkit-text-stroke-color: #000;
	font-family: Baloo;
	font-style: normal;
	font-weight: 400;
	min-width: 5.7em;
	display: flex;
	justify-content: center;
`;

export const Box = styled("div")`
	border-radius: 8px;
	border: 0.027em solid #fff;
	background: linear-gradient(0deg, #ffe083 0%, #e7e7e7 100%);
	box-shadow: 0em 0.05em 0.1em 0em rgba(0, 0, 0, 0.25);
	min-width: 1.7em;
`;

export const Number = styled("span")`
	font-size: 0.92em;
	-webkit-text-stroke-width: 0.1em;
	paint-order: stroke fill;
`;

export const Text = styled("span")`
	font-size: 0.4em;
	-webkit-text-stroke-width: 0.2em;
	paint-order: stroke fill;
`;

export const Separator = styled("span")`
	font-size: 0.45em;
	-webkit-text-stroke-width: 0.14em;
	paint-order: stroke fill;
	&::after {
		content: ":";
	}
`;
